"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Typography = _interopRequireWildcard(require("../../../../atoms/Typography/index.js"));
var _themeProvider = require("../../../../../theme/themeProvider/index.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const StyledLabel = exports.StyledLabel = _styledComponents.default.label`
    ${({
  gaugeSize,
  currentPercentage
}) => {
  return `
        bottom: 0; 
        font-size: 16px;
        transform-origin: bottom center; 
        white-space: nowrap; 
        transform: rotate(${currentPercentage}deg) ;
		left: 0;
		position: absolute;
        height: ${20 + gaugeSize / 2}px;
        `;
}}
`;
const StyledLabelContainer = _styledComponents.default.div`
    ${({
  gaugeSize
}) => {
  return `
        width: ${gaugeSize}px;
        height: ${gaugeSize / 2}px;
		position: absolute;
		display: flex;
		justify-content: center;
		transform: translate(45%,-5%);
        `;
}}
`;
const GaugeLabels = props => {
  const {
    gaugeLabels,
    gaugeSize
  } = props;
  const theme = (0, _themeProvider.useTheme)();
  const totalLabels = gaugeLabels.length;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLabelContainer, {
    gaugeSize: gaugeSize,
    children: gaugeLabels.map((label, index) => {
      const percentageCalc = 180 / (gaugeLabels.length - 1) * index;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLabel, {
        className: "gauge-label",
        gaugeSize: gaugeSize,
        currentPercentage: percentageCalc - 90,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: _Typography.typographyVariantEnum.label,
          color: theme.color.defaultLabelColor,
          children: label
        })
      });
    })
  });
};
var _default = exports.default = GaugeLabels;